import http from '../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import utils from '../utils';
import { Table, Input, Button, Modal, Form, Row, Col, Checkbox, Select, Popover, Menu, Dropdown } from 'antd';
import { CloudDownloadOutlined, ExclamationCircleOutlined, UpOutlined, DownOutlined, SwapRightOutlined } from '@ant-design/icons';
import defs from "./defs"
import BurningAddGeneral from "./BurningAddGeneral";
import BurningAddGeneralPassThrough from "./BurningAddGeneralPassThrough";
import BurningAddEnergyPortPassthrough from "./BurningAddEnergyPortPassthrough.js";
import BurningAddMasterControl from "./BurningAddMasterControl.js";
import BurningController from "./BurningController";
import InputPrefix from '../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    df: {
        backgroundColor: "#e5ffff"
    }
}));

function BurningManagement(props) {
    const setTip = useContext(utils.tipContext);
    const { t } = useTranslation();

    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [params, setParams] = useState({
        SN: '',
        ProductName: '',
        DistributorName: '',
        UserID: '',
        FirmwareName: '',
        BurningType: '',
        FirmwareVersion: '',
        Burned: '',
        NotExpired: '',
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rowTotal, setRowTotal] = useState(0);
    const [tableBodyHeight, setTableBodyHeight] = useState(240);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [showAddGeneral, setShowAddGeneral] = useState(false);
    const [showAddGeneralPassThrough, setShowAddGeneralPassThrough] = useState(false);
    const [showAddEnergyPortPassthrough, setShowAddEnergyPortPassthrough] = useState(false);
    const [showAddMasterControl, setShowAddMasterControl] = useState(false);
    const [productSelectOptions, setProductSelectOptions] = useState([]);
    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);
    const [expand, setExpand] = useState(false);
    const [controlBurningInfo, setControlBurningInfo] = useState(null);

    const refTableContainer = useRef();
    const refTimerProductSearcher = useRef(null);
    const refProductSearchValue = useRef(null);
    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);

    const [form] = Form.useForm();

    const classes = useStyles();

    useEffect(() => {
        let active = true;
        console.log("BurningManagement Effect");

        (async () => {
            setLoading(true);


            let resp = await http.post("burning/management/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                ...params,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_data_error") });

                setRowTotal(0)
                setRows([]);

                return;
            }
            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
            console.log("BurningManagement Effect Cancel");
        };
    }, [pageNo, pageSize, params]);

    useEffect(() => {
        const el = refTableContainer.current;

        if (el.objResizer) {
            return;
        }

        let obj = document.createElement('object');
        el.objResizer = obj;
        obj.setAttribute('style',
            'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
        obj.onload = function () {
            setTableBodyHeight(calcTableBodyHeight());

            this.contentDocument.defaultView.addEventListener('resize', (evt) => {
                setTableBodyHeight(calcTableBodyHeight());
            });
        };
        obj.type = 'text/html';
        el.appendChild(obj);
        obj.data = 'about:blank';

        return () => {
            if (!el) {
                return
            }

            //
        }
    }, [refTableContainer.current]);

    const handleSearchProduct = (v) => {
        if (refTimerProductSearcher.current != null) {
            clearTimeout(refTimerProductSearcher.current);
        }
        refProductSearchValue.current = v;

        refTimerProductSearcher.current = setTimeout(async () => {
            const resp = await http.post("product/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (refProductSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_product_list_error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setProductSelectOptions(ls);
            } catch (e) {
                console.log("[BurningManagement]", e);

                setTip({ open: true, severity: "error", msg: t("load_product_list_error") });
            }
        }, 300);
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_distributor_list_error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch (e) {
                console.log("[BurningManagement]", e);

                setTip({ open: true, severity: "error", msg: t("load_distributor_list_error") });
            }
        }, 300);
    }

    const handleSearch = () => {
        setSelectedKeys([]);
        setPageNo(0);

        const ps = form.getFieldsValue();
        //console.log(ps, "<<<------")
        ps.SN = ps.SN || "";
        ps.FirmwareName = ps.FirmwareName || "";
        ps.ProductName = ps.ProductName || "";
        ps.DistributorName = ps.DistributorName || "";
        ps.UserID = ps.UserID || "";
        ps.BurningType = ps.BurningType || "";
        ps.FirmwareVersion = ps.Version || "";
        ps.Burning = (ps.Burning || []).join(",")
        setParams({ ...ps });
    }

    const renderAction = (v, r, idx) => {
        if (r.BurningCategory === "1" && r.ViaMaster !== "0") {
            return;
        }

        const btns = [];
        const btnIgnore = <Button key="Ignore" onClick={() => { handleIgnore(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t("Ignore")}</Button>;
        const btnRestart = <Button key="Restart" onClick={() => { handleRestart(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }}>{t("Restart")}</Button>;
        const btnControl = <Button key="Control" onClick={() => { handleControl(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }} >{t("Control")}</Button>;
        if (r.EventCode === "99999") {
            btns.push(<Button key="Confirm" onClick={() => { handleConfirm(r, idx) }} type="primary" size="small" style={{ marginRight: "3px" }} >{t("Confirm")}</Button>);
            btns.push(btnIgnore);
        } else if (r.EventCode === "9" || r.EventCode === "1") {
            btns.push(btnControl);
            btns.push(btnIgnore);
        } else if (r.EventCode === "3" || r.EventCode === "5") {
            btns.push(btnRestart);
            btns.push(btnIgnore);
        }

        return (
            <>{btns}</>
        )
    }

    const handleAdd = (item) => {
        if (item.key === "GeneralBurning") {
            setShowAddGeneral(true);
        } else if (item.key === "GeneralPass-throughBurning") {
            setShowAddGeneralPassThrough(true);
            //} else if (item.key === "EnergyPortBurning") {
            //    setTip({open:true, severity:"info", msg:"Energy Port Burning Coming Soon"})
        } else if (item.key === "EnergyPortPass-throughBurning") {
            //setTip({open:true, severity:"info", msg:"Energy Port Pass-through Burning Coming Soon"})
            setShowAddEnergyPortPassthrough(true);
        } else if (item.key === "Master-ControlBurning") {
            setShowAddMasterControl(true);
        }
    }

    const handleConfirm = async (row, index) => {
        try {
            const resp = await http.post("device/upgrade/request/do", {
                DeviceID: row.ID,
                BurningID: row.BurningID,
                FirmwareID: row.FirmwareID,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("Confirm error") });
                return;
            }

            const data = resp.data;

            if (data["EventCode"] === 1 || data["EventCode"] === 9) {
                setTip({ open: true, severity: "success", msg: t("Confirm success") })

                setRows([...rows.slice(0, index), { ...row, EventCode: data["EventCode"].toString() }, ...rows.slice(index + 1)]);
            } else {
                setTip({ open: true, severity: "error", msg: t("Confirm error") });
            }
        } catch (e) {
            console.log("[BurningManagement]", e)
            setTip({ open: true, severity: "error", msg: t("Confirm error") });
        }
    }

    const handleIgnore = async (row, index) => {
        try {
            const resp = await http.post("device/upgrade/ignore/do", {
                DeviceID: row.ID,
                BurningID: row.BurningID,
                FirmwareID: row.FirmwareID,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("Ignore error") });
                return;
            }

            const data = resp.data;

            if (data["EventCode"] === 0) {
                setTip({ open: true, severity: "success", msg: t("Ignore success") })

                setRows([...rows.slice(0, index), { ...row, EventCode: data["EventCode"].toString() }, ...rows.slice(index + 1)]);
            } else {
                setTip({ open: true, severity: "error", msg: t("Ignore error") });
            }
        } catch (e) {
            console.log("[BurningManagement]", e)
            setTip({ open: true, severity: "error", msg: t("Ignore error") });
        }
    }

    const handleControl = async (row, index) => {
        setControlBurningInfo({ ...row });
    }

    const handleRestart = async (row, index) => {
        try {
            const resp = await http.post("device/upgrade/request/do", {
                DeviceID: row.ID,
                BurningID: row.BurningID,
                FirmwareID: row.FirmwareID,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[BurningManagement]", e);
                return null;
            });

            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("Restart error") });
                return;
            }

            const data = resp.data;

            if (data["EventCode"] === 1 || data["EventCode"] === 9) {
                setTip({ open: true, severity: "success", msg: t("Restart success") })

                setRows([...rows.slice(0, index), { ...row, EventCode: data["EventCode"].toString() }, ...rows.slice(index + 1)]);
            } else {
                setTip({ open: true, severity: "error", msg: t("Restart error") });
            }
        } catch (e) {
            console.log("[BurningManagement]", e)
            setTip({ open: true, severity: "error", msg: t("Restart error") });
        }
    }


    const handleSelect = (selectedRowKeys, selectedRows) => {
        setSelectedKeys([...selectedRowKeys]);
    }

    const handleAddingClose = (rs) => {
        setShowAddGeneral(false);
        setShowAddGeneralPassThrough(false);
        setShowAddEnergyPortPassthrough(false);
        setShowAddMasterControl(false);

        if (!rs) {
            return;
        }

        // document.getElementsByClassName("ant-table-body")[0].scrollTo(0, 0);
        // setSelectedKeys([...(rs instanceof Array ? rs.map((r)=>r.ID) : [rs.ID])]);
        // setRows([...(rs instanceof Array ? rs : [rs]), ...rows]);
        // setRowTotal(rowTotal+(rs instanceof Array ? rs.length : 1));

        handleSearch();
    }

    const calcTableBodyHeight = () => {
        if (!refTableContainer.current) {
            return 240;
        }

        const hd = document.getElementsByClassName("ant-table-thead")[0];

        const h = refTableContainer.current.getBoundingClientRect().bottom - hd.getBoundingClientRect().bottom;

        return h >= 54 ? h - 54 : h / 2;
    }

    //按下Enter键时进行查找
    const searchByEnter = (e) => {
        if (e.code == "Enter") {
            handleSearch()
        }
    }

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: '#EFF8FE',
            padding: 8,
        }}>
            <div style={{
                flex: "0 1 auto",
            }}>
                <Form
                    form={form}
                    initialValues={{
                        Burning: [t("No-Upgrade"), t('Done'), t('Ignored'), t("Expired"), t('To-Be-Confirmed'), t('Errored'), t('In-Progress')],
                    }}
                    style={{
                        padding: 24,
                        background: '#fbfbfb',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2
                    }}
                >
                    <Row gutter={24}>
                        <Col span={8} key="SN">
                            <Form.Item
                                name="SN"
                                label=""
                            >
                                <Input prefix={<InputPrefix label="SN" />} placeholder={t("Enter Device SN")} onPressEnter={handleSearch} style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={10} style={{textAlign: 'left'}}>
                            <Button type="primary" shape='round' style={{marginRight: '8px'}} onClick={handleSearch}>
                                {t("Search")}
                            </Button>
                            <a
                                style={{ fontSize: 12, marginRight: '20px' }}
                                onClick={() => {
                                    setExpand(!expand);
                                }}
                            >
                                {expand ? <UpOutlined /> : <DownOutlined />} {expand ? t("Collapse") : t("Expand")}
                            </a>
                        </Col>
                        <Col span={6} key="FirmwareName">
                            <Form.Item
                                name="FirmwareName"
                                label=""
                            >
                                <Input prefix={<InputPrefix label={t("FirmwareName")} />} placeholder={t("Enter Firmware Name")} onPressEnter={handleSearch} style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={4} key="BurningType" style={{ display: "none" }}>
                            <Input.Group compact>
                                <Button>{t("UpgradeType")}</Button>
                                <Form.Item
                                    name="BurningType"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 120px)'}}
                                >
                                    <Select onInputKeyDown={searchByEnter}>
                                        <Select.Option value={1}>APP</Select.Option>
                                        <Select.Option value={2}>BOOT</Select.Option>
                                        <Select.Option value={3}>stm32 bootloader</Select.Option>
                                        <Select.Option value={4}>stm32 application</Select.Option>
                                        <Select.Option value={5}>280049 application</Select.Option>
                                        <Select.Option value={6}>280049 flash</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8} key="Product" style={{ display: expand ? "block" : "none" }}>
                            <Input.Group compact>
                                <Button>{t("Product")}</Button>
                                <Form.Item
                                    name="ProductName"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 80px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("Enter Product Name")}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={handleSearchProduct}
                                        onInputKeyDown={searchByEnter}
                                    >{productSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8} key="Distributor" style={{ display: expand ? "block" : "none" }}>
                            <Input.Group compact>
                                <Button>{t("Distributor")}</Button>
                                <Form.Item
                                    name="DistributorName"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 100px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("Enter Distributor Name")}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={handleSearchDistributor}
                                        onInputKeyDown={searchByEnter}
                                    >{distributorSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8} key="UserID" style={{ display: expand ? "block" : "none" }}>
                            <Form.Item
                                name="UserID"
                                label=""
                            >
                                <Input prefix={<InputPrefix label={t('UserID')}/>} placeholder={t("Enter UserID")} onPressEnter={handleSearch} style={{ borderRadius: '20px' }} />
                            </Form.Item>
                        </Col>
                        <Col span={24} key="Burning" style={{ display: expand ? "block" : "none" }}>
                            <Form.Item
                                name="Burning"
                                label=""
                            >
                                <Checkbox.Group options={[
                                    { label: t("No-Upgrade"), value: "No-Upgrade" },
                                    { label: t("Done"), value: "Done" },
                                    { label: t("Ignored"), value: "Ignored" },
                                    { label: t("Expired"), value: "Expired" },
                                    { label: t("To-Be-Confirmed"), value: "To-Be-Confirmed" },
                                    { label: t("Errored"), value: "Errored" },
                                    { label: t("In-Progress"), value: "In-Progress" }
                                ]} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Button
                                shape='round'
                                onClick={() => {
                                    form.resetFields();
                                }}
                            >
                                {t("Clear")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingTop: 8,
                paddingBottom: 8,
            }}>
                <Dropdown
                    overlay={<Menu onClick={handleAdd}>
                        <Menu.Item key="GeneralBurning">{t("General Upgrade")}</Menu.Item>
                        <Menu.Item key="GeneralPass-throughBurning">{t("General Pass-through Upgrade")}</Menu.Item>
                        <Menu.Item key="EnergyPortPass-throughBurning">{t("Energy Port Pass-through Upgrade")}</Menu.Item>
                        <Menu.Item key="Master-ControlBurning">{t("Master-Control Upgrade")}</Menu.Item>
                    </Menu>}
                >
                    <Button type="primary" icon={<CloudDownloadOutlined />} size="middle" shape="round" style={{ marginLeft: 5 }}>{t("Add Upgrade")}</Button>
                </Dropdown>
            </div>
            <div style={{
                flex: "1 1 1px",
                position: "relative",
            }}>
                <div ref={refTableContainer} style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden" }}>
                    <Table
                        columns={[{
                            title: "",
                            width: 70,
                            fixed: 'left',
                            render: (v, r, idx) => {
                                return (pageNo * pageSize + idx + 1);
                            }
                        }, {
                            title: "SN",
                            dataIndex: 'SN',
                            width: 220,
                            fixed: 'left',
                            render: (v, r) => {
                                const content = (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        minWidth: 400
                                    }}>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t("Product")}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.ProductName}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t("Distributor")}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.DistributorName}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t("Users")}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.Users}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t("BurnedBoot")}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.BurnedBootFirmwareVersion ? "V" + r.BurnedBootFirmwareVersion + ", " : ""}&nbsp;{r.BurnedBootFirmwareEventTime || ""}</div>
                                        </div>
                                        <div style={{
                                            display: "flex"
                                        }}>
                                            <div style={{
                                                flex: "0 0 90px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                            }}>{t("BurnedApp")}:&nbsp;</div>
                                            <div style={{ flex: "1" }}>{r.BurnedAppFirmwareVersion ? "V" + r.BurnedAppFirmwareVersion + ", " : ""}&nbsp;{r.BurnedAppFirmwareEventTime || ""}</div>
                                        </div>
                                    </div>
                                );
                                return (
                                    <Popover title={t("Note")} content={content}>
                                        <div>{v}</div>
                                    </Popover>
                                );
                            }
                        }, {
                            title: t("Upgrade Category"),
                            dataIndex: "BurningCategory",
                            width: 200,
                            render: (v) => {
                                const cs = {
                                    "0": t("General"),
                                    "1": t("General Pass-through"),
                                    "2": t("Energy Port"),
                                    "3": t("Energy Port Pass-through"),
                                    "4": t("Master-Control"),
                                }

                                return cs[v] || "";
                            }
                        }, {
                            title: t("FirmwareName"),
                            dataIndex: "FirmwareName",
                            width: 200,
                        }, {
                            title: t("FirmwareVersion"),
                            dataIndex: "FirmwareVersion",
                            width: 80,
                        }, {
                            title: t("Upgrade Type"),
                            dataIndex: "BurningType",
                            width: 100,
                            render: (v, r, idx) => {
                                if (r.ProductCategory == "1") {
                                    return defs.burningTypesForEnergyPort[v] || "";
                                } else if (r.ProductID == "2b7f7c7e-66cd-46e0-9dbb-20193cb740dd") {
                                    return defs.burningTypesForAllInOneC10kW[v] || "";
                                } else {
                                    return defs.burningTypes[v] || "";
                                }
                            }
                        }, {
                            title: t("DataLength"),
                            dataIndex: "DataLength",
                            width: 140,
                            render: (v) => {
                                return v ? Math.round(v/1024) + 'KB (' + v + 'B)' : ''
                            }
                        }, {
                            title: t("ExpiredTime"),
                            dataIndex: "ExpiredTime",
                            width: 150,
                            render: (v) => {
                                return v && v != "0000-00-00 00:00:00" ? v : "";
                            }
                        }, {
                            title: t("Note"),
                            dataIndex: "Note",
                            width: 200,
                            render: (v) => {
                                if (!v) {
                                    return v;
                                }

                                if (v.indexOf("\n") > -1) {
                                    const content = (
                                        <Input.TextArea rows={5} value={v} readOnly />
                                    )
                                    return (
                                        <Popover title={t("Note")} content={content}>
                                            <div style={{minWidth:"400px"}}>{v}</div>
                                        </Popover>
                                    );
                                }

                                return v;
                            }
                        }, {
                            title: t("Master Pass-through | Via Master"),
                            dataIndex: "UpgradingDeviceSNs",
                            width: 200,
                            className: classes.df,
                            render: (v, r) => {
                                if (r["ViaMaster"] === null) {
                                    return "";
                                } else if (r["ViaMaster"] !== "0") {
                                    return t("ViaMaster");
                                } else {
                                    return v;
                                }
                            }
                        }, {
                            title: t("Upgrade Time"),
                            dataIndex: "STime",
                            width: 200,
                            className: classes.df,
                            render: (v, r) => {
                                if (v) {
                                    return (
                                        <p>
                                            {v}&nbsp;
                                            <SwapRightOutlined color="#aaa" />
                                            &nbsp;{r["ETime"] || ""}
                                        </p>
                                    )
                                } else {
                                    return "";
                                }
                            }
                        }, {
                            title: t("Progress"),
                            dataIndex: "Progress",
                            width: 200,
                            className: classes.df,
                            render: (v, r) => {
                                const code = r["EventCode"];
                                if (code === "99999") {
                                    return t("To be confirmed");
                                } else if (code === "0") {
                                    return t("Ignored");
                                } else if (code === "9") {
                                    return t("To be burned");
                                } else if (code === "2") {
                                    return <label style={{ color: "#32cb00" }}>{t("Burned")}</label>;
                                } else if (code === "3") {
                                    return <label style={{ color: "red" }}>{t("Error")}</label>;
                                } else if (code === "4") {
                                    return t("Expired");
                                } else if (code === "1") {
                                    return <label style={{ color: "blue" }}>{(v * 100 / r["DataLength"]).toFixed(1) + "%"}</label>;
                                }
                                if (v) {
                                    return (
                                        <p>
                                            {v}&nbsp;
                                            <SwapRightOutlined color="#aaa" />
                                            &nbsp;{r["ETime"] || ""}
                                        </p>
                                    )
                                } else {
                                    return "";
                                }
                            }
                        }, {
                            title: t("Create Time"),
                            dataIndex: 'CreateTime',
                            width: 150,
                            className: classes.df,
                        }, {
                            title: t('Action'),
                            key: 'Action',
                            width: 150,
                            render: renderAction,
                        }]}
                        pagination={{
                            pageSizeOptions: [25, 50, 100],
                            current: pageNo + 1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => { return t("Total")+" "+ total },
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page - 1);
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="middle"
                        loading={loading}
                        rowKey="ID"
                        dataSource={rows}
                        scroll={{ x: 1500, y: tableBodyHeight }}
                        rowSelection={{
                            selectedRowKeys: selectedKeys,
                            onChange: handleSelect,
                            selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
                            getCheckboxProps: (r) => {
                                if (r.BurningCategory === "1" && r.ViaMaster !== "0") {
                                    return {
                                        disabled: true,
                                    }
                                }

                                return null;
                            }
                        }}
                    />
                </div>
            </div>
            <BurningAddGeneral show={showAddGeneral} onClose={handleAddingClose} />
            <BurningAddGeneralPassThrough show={showAddGeneralPassThrough} onClose={handleAddingClose} />
            <BurningAddEnergyPortPassthrough show={showAddEnergyPortPassthrough} onClose={handleAddingClose} />
            <BurningAddMasterControl show={showAddMasterControl} onClose={handleAddingClose} />
            {controlBurningInfo !== null ? (
                <BurningController
                    show={controlBurningInfo !== null}
                    sn={controlBurningInfo.SN}
                    deviceID={controlBurningInfo.ID}
                    burningID={controlBurningInfo.BurningID}
                    burningType={controlBurningInfo.BurningType}
                    firmwareID={controlBurningInfo.FirmwareID}
                    dataLength={controlBurningInfo.DataLength}
                    onClose={() => { setControlBurningInfo(null); }}
                />
            ) : ""}
        </div>
    );
}

export default BurningManagement;